export const styles = {
  companiesLogos: (theme) => ({
    gap: '30px 0',
    [theme.breakpoints.down('xl')]: {
      '> div:nth-last-of-type(2)': {
        backgroundColor: 'green',
        display: 'none',
      },
    },
  }),
  logo: (theme) => ({
    textAlign: 'center',
    height: '63px',
    '> svg': {
      height: '63px',
      margin: 'auto',
    },
    [theme.breakpoints.down('lg')]: {
      height: '45px',
      '> svg': {
        height: '45px',
        maxWidth: '150px',
        margin: 'auto',
      },
    },
    [theme.breakpoints.down('sm')]: {
      height: '25px',
      '> svg': {
        height: '25px',
        maxWidth: '110px',
        margin: 'auto',
      },
    },
  }),
};
